export const PhoneTypesData = [
  { title: 'Standard', value: 1 },
  { title: 'Ligne directe', value: 2 },
  { title: 'Mobile', value: 3 },
  { title: 'Fax/télécopie', value: 4 }
]
